import { Component } from 'react';
import './ApiKeyFormComponent.scss';
import { DateTime } from "luxon";
import {Label, Switch} from 'app/components/Basics/';
import { Input as TextInput } from '@ecosystem/ui-lib/core/components/Input';
import {ApiKeysContext} from '../ApiKeysContext'

class ApiKeyForm extends Component {

    constructor(props){
        super(props);
        this.state = {
        }        
    }

	apiKeyNameHandler = async (event) => {		
		var apiKey = this.props.apiKey;
		apiKey.name = event.target.value;
		if (apiKey.name && apiKey.name.length > 125) {
			apiKey.name = apiKey.name.substring(0, 124);
		}
		await this.context.updateSelectedApiKey(apiKey);
    }

	apiKeyDescriptionHandler = async (event) => {		
		var apiKey = this.props.apiKey;
		apiKey.description = event.target.value;		
		await this.context.updateSelectedApiKey(apiKey);
    }

	
    render() {
		return (
            <div className='AppFormComponent'>
				<div className="ApiKeyFormComponent form-row">
					<div className="form-row-left">
						<div className="field-api-key-id">
							<Label tooltip="">Api Key Id</Label>
							<TextInput disabled={true} value={this.props.apiKey.id} id="api-key-id"/>
						</div>
						<div className="field-created-at">
							<Label>Created At</Label>
							<TextInput disabled={true} value={this.props.apiKey.createdAt ? DateTime.fromISO(this.props.apiKey.createdAt).toString("dd/MM/yyyy HH:mm:ss") : ""} id="created-at"/>
						</div>
						<div className="field-active">
							<Label>Active</Label>
							<div className="default-height centered"><Switch disabled={true} name="active" checked={this.props.apiKey.active === 1}/></div>
						</div>
						<div className="field-last-used-at">
							<Label>Last Used At</Label>
							<TextInput disabled={true} value={this.props.apiKey.lastUsedAt ? DateTime.fromISO(this.props.apiKey.lastUsedAt).toString("dd/MM/yyyy HH:mm:ss") : ""} id="last-used-at"/>
						</div>					
					</div>
				</div>
				<div className="TemplateFormComponent form-row">
					<div className="form-row-left">
						<div className="field-api-key-name">
							<Label tooltip="">Name</Label>
							<TextInput disabled={false}		
								type='String'						
								value={this.props.apiKey.name}
								onChange={this.apiKeyNameHandler}
								id="api-key-name"
								>							
							</TextInput>						
						</div>
						<div className="field-api-key-created-by">
							<Label tooltip="">Created By</Label>
							<TextInput disabled={true} value={this.props.apiKey.createdBy} id="created-by"/>
						</div>
					</div>
				</div>
				<div className="TemplateFormComponent form-row">
					<div className="form-row-left">
						<div className="field-api-key-description">
							<Label tooltip="">Description</Label>
							<TextInput disabled={false}		
								type='String'						
								value={this.props.apiKey.description}
								onChange={this.apiKeyDescriptionHandler}
								id="api-key-description"
								>							
							</TextInput>						
						</div>
					</div>
				</div>
			</div>
        );
    }
}
ApiKeyForm.contextType = ApiKeysContext;
export default ApiKeyForm;